import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { checkoutInfoProps } from "@store/theme/common/props/checkout";

Object.assign(orderDateStyles, {
    wrapper: {},
    titleText: checkoutInfoProps.label,
    orderDate: checkoutInfoProps.value,
});
